/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import { IImmunizationEligibility } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface IImmunizationEligibilityProps {
	data: IImmunizationEligibility
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IImmunizationEligibilityState {}

export class ImmunizationEligibilityComponent extends React.Component<IImmunizationEligibilityProps, IImmunizationEligibilityState> {
	render(): JSX.Element {
		return (
			<tr>
				<td className="bottom-border-td">Medicare Part B:</td>
				{this.props.data.medicarePartBEligible !== undefined ? (
					<td className="bottom-border-td" colSpan={3} style={{ color: this.props.data.medicarePartBEligible ? '' : 'Red' }}>
						{this.props.data.medicarePartBEligible ? 'Eligible' : 'Ineligible'}
					</td>
				) : (
					<td className="bottom-border-td no-info" colSpan={3}>
						No Part B information available
					</td>
				)}
			</tr>
		)
	}
}
